/**
 * Standard-specific calculation functions for various cybersecurity frameworks
 * This file contains functions for NIST, CIS, ISO, NYCRR, FCARM, and UCIS standards
 */

(function($) {
	function showFrameworkContainer(selector) {
		if (typeof window.applyFrameworkPanelVisibility === 'function') {
			window.applyFrameworkPanelVisibility('show', selector);
		} else {
			$(selector).show();
		}
	}
	function hideFrameworkContainer(selector) {
		if (typeof window.applyFrameworkPanelVisibility === 'function') {
			window.applyFrameworkPanelVisibility('hide', selector);
		} else {
			$(selector).hide();
		}
	}
	/**
	 * NIST CSF 1.1 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function NISTCSF11(averageScores, charts) {
	// Filter to only NIST-CSF-1.1 data for easier debugging
	const nistScores = Object.keys(averageScores)
		.filter(key => key.startsWith('NIST-CSF-1.1'))
		.reduce((obj, key) => {
			obj[key] = averageScores[key];
			return obj;
		}, {});
	
	// console.log('NIST-CSF-1.1 scores only:', nistScores);
	
	// Debug: Show which keys have NaN values and their original values
	const nanKeys = Object.keys(nistScores).filter(key => isNaN(nistScores[key]));
	if (nanKeys.length > 0) {
		// console.log('Keys with NaN values:', nanKeys);
		// console.log('Original values for NaN keys:', nanKeys.map(key => ({ key, value: averageScores[key] })));
		
		// Debug: Check if these keys exist in the original averageScores
		// console.log('Checking original averageScores for NaN keys:');
		nanKeys.forEach(key => {
			// console.log(`${key}: ${averageScores[key]} (type: ${typeof averageScores[key]})`);
		});
	}
	
	const tableBody = document.querySelector('#nist11 tbody');
    hideFrameworkContainer('.nist11-container');
	if (!tableBody) {
		console.error('NIST CSF 1.1 Table body not found.');
		return;
	}

	// Object to store total scores and count of controls for each subcategory
	const categoryTotals = {};

	// Aggregate scores for each control under each main subcategory
	Object.keys(nistScores).forEach(key => {
		// Extract the category by splitting the key and getting the second part
		// Key format: 'NIST-CSF-1.1-DE.AE-1'
		const parts = key.split('-');  // Splits into ['NIST', 'CSF', '1.1', 'DE.AE', '1']
		const category = parts[3];  // This will be 'DE.AE'

		if (!categoryTotals[category]) {
			categoryTotals[category] = { total: 0, count: 0 };
		}
		
		// Only add valid numbers (not NaN) to the total
		const score = nistScores[key];
		if (!isNaN(score) && score !== null && score !== undefined) {
			categoryTotals[category].total += score;
			categoryTotals[category].count++;
		} else {
			// console.log(`Skipping invalid score for ${key}: ${score}`);
		}
	});

	// console.log('Category totals for NIST-CSF-1.1:', categoryTotals);

	// Calculate the average for each subcategory and update the table
	Array.from(tableBody.rows).forEach((row, index) => {
		const categoryLabel = row.cells[0].textContent.trim();  // Assuming the label format contains 'DE.AE' directly
		const regex = /\((DE|ID|PR|RS|RC)\.([A-Z]+)\)/;  // Matches like '(DE.AE)'
		const match = categoryLabel.match(regex);

		if (match) {
			const category = match[1] + '.' + match[2];
			if (categoryTotals[category]) {
				const averageScore = (categoryTotals[category].total / categoryTotals[category].count) * 5;
				row.cells[1].textContent = averageScore.toFixed(2);
				//console.log(`Updated ${category} in row ${index} with average score ${averageScore.toFixed(2)} with a count of ${categoryTotals[category].count}`);
			} else {
				row.cells[1].textContent = "0.00";
				//console.log(`No data for category ${category} at row ${index}`);
			}
		} else {
			//console.log(`No regex match found for category label at row ${index}: ${categoryLabel}`);
			row.cells[1].textContent = "0.00";
		}
	});

	// Build a simple category averages object for the core function utility
	const categoryAverages = {};
	Object.keys(categoryTotals).forEach(category => {
		if (categoryTotals[category].count > 0) {
			// Divide by 5 because calculateCoreFunctionAverages multiplies by 5
			categoryAverages[category] = categoryTotals[category].total / categoryTotals[category].count;
		}
	});

	// Calculate core function averages using utility function
	const coreFunctionAverages = calculateCoreFunctionAverages(categoryAverages);

	let totalScore = 0;
	let scoreCount = 0;
	Array.from(tableBody.rows).forEach(row => {
		const scoreText = row.cells[1].textContent;
		if (scoreText) {
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		}
	});

	// Update the core functions table with calculated averages using utility function
	updateCoreFunctionsTable('nist11-core-functions', coreFunctionAverages, formatScore);

	// Calculate overall maturity from core functions table instead of safeguard domains
	const coreFunctionsTable = document.querySelector('#nist11-core-functions tbody');
	var overallMaturity = 0;
	if (coreFunctionsTable) {
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(coreFunctionsTable.rows).forEach(row => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});
		
		if (scoreCount > 0) {
			overallMaturity = totalScore / scoreCount;
		}
	} else {
		// Fallback: calculate from core function averages object if table not found
		const coreFunctionValues = Object.values(coreFunctionAverages);
		if (coreFunctionValues.length > 0) {
			overallMaturity = coreFunctionValues.reduce((sum, value) => sum + value, 0) / coreFunctionValues.length;
		}
	}

	// Update the overall maturity score
	const maturityRatingRow = $('#nist11 .light-background td');
	if (maturityRatingRow.length > 0) {
		WebAssessmentCharts.overallNISTCSF11maturity = overallMaturity;
		WebAssessmentCharts.nist11CoreFunctionAverages = coreFunctionAverages;  // Store core function averages
		//console.log('overallMaturity', overallMaturity);
		maturityRatingRow.text(formatScore(overallMaturity));  // jQuery method to set text
        $('.audit-overall-value').text(formatScore(overallMaturity));
        $('.nist11-overall-value').text(formatScore(overallMaturity));
        // console.log(`Updated audit-overall-value with core functions table average:`, formatScore(overallMaturity));
        WebAssessmentCharts.createChartFromTable('nist11', 'nist11-chart', charts, true);
        WebAssessmentCharts.createChartFromTable('nist11-core-functions', 'nist11-core-functions-chart', charts, true);
        showFrameworkContainer('.nist11-container');
		//console.log(`Overall maturity rating calculated from table and updated to ${formatScore(overallMaturity)}`);
	} else {
		console.error("Error: Maturity rating row not found in the table.");
	}
	}

	/**
	 * NIST CSF 2.0 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function NISTCSF2(averageScores, charts) {
		// console.log('averageScores in NISTCSF2 func', averageScores);

		// Check if we have any averages data
		if (!averageScores || Object.keys(averageScores).length === 0) {
			// console.warn('No averages data available for NIST CSF 2.0');
			hideFrameworkContainer('.nist2-container');
			return;
		}

		hideFrameworkContainer('.nist2-container');
		const tableBody = document.querySelector('#nist2 tbody');
		if (!tableBody) {
			console.error('NIST CSF 2.0 table body not found.');
			return;
		}

		// Object to store total scores and count of controls for each subcategory
		const categoryTotals = {};
		
		// Object to store total scores and count of controls for each core function
		const coreFunctionTotals = {};

		// Aggregate scores for each control under each main subcategory
		Object.keys(averageScores).forEach(key => {
			let category, coreFunction;
			
			// Check for NIST-CSF-2.0 format first (for CRF calculations)
			if (key.startsWith('NIST-CSF-2.0-')) {
				const parts = key.split('-');
				if (parts.length >= 4) {
					category = parts[3];  // e.g., 'DE.AE'
					coreFunction = category.split('.')[0];  // e.g., 'DE'
				}
			}
			// Check for direct format like 'DE.AE', 'GV.OC', etc. (for NIST CSF 2.0 calculations)
			else {
				const coreFunctionMatch = key.match(/^([A-Z]{2})\./);
				if (coreFunctionMatch) {
					category = key;  // The key itself is the category like 'DE.AE'
					coreFunction = coreFunctionMatch[1];  // This will be 'DE', 'GV', etc.
				}
			}
			
			// Process if we found a valid category and core function
			if (category && coreFunction) {
				// Store for subcategory totals
				if (!categoryTotals[category]) {
					categoryTotals[category] = { total: 0, count: 0 };
				}
				categoryTotals[category].total += averageScores[key];
				categoryTotals[category].count++;
				
				// Store for core function totals
				if (!coreFunctionTotals[coreFunction]) {
					coreFunctionTotals[coreFunction] = { total: 0, count: 0 };
				}
				coreFunctionTotals[coreFunction].total += averageScores[key];
				coreFunctionTotals[coreFunction].count++;
			}
		});

		// Calculate the average for each subcategory and update the table
		Array.from(tableBody.rows).forEach((row, index) => {
			const categoryLabel = row.cells[0].textContent.trim();  // Assuming the label format contains 'DE.AE' directly
			const regex = /\((DE|ID|PR|RS|RC|GV)\.([A-Z]+)\)/;  // Matches like '(DE.AE)'
			const match = categoryLabel.match(regex);

			if (match) {
				const category = match[1] + '.' + match[2];
				if (categoryTotals[category]) {
					const averageScore = (categoryTotals[category].total / categoryTotals[category].count) * 5;
					row.cells[1].textContent = averageScore.toFixed(2);
				} else {
					row.cells[1].textContent = "0.00";
				}
			} else {
				row.cells[1].textContent = "0.00";
			}
		});

	// Build a simple category averages object for the core function utility
	const categoryAverages = {};
	Object.keys(categoryTotals).forEach(category => {
		if (categoryTotals[category].count > 0) {
			// Divide by 5 because calculateCoreFunctionAverages multiplies by 5
			categoryAverages[category] = categoryTotals[category].total / categoryTotals[category].count;
		}
	});

	// Calculate core function averages using utility function
	const coreFunctionAverages = calculateCoreFunctionAverages(categoryAverages);
	
	let totalScore = 0;
	let scoreCount = 0;
	Array.from(tableBody.rows).forEach((row, index) => {
		const scoreText = row.cells[1].textContent;
		if (scoreText) {
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		}
	});

	// Update the core functions table with calculated averages using utility function
	updateCoreFunctionsTable('nist2-core-functions', coreFunctionAverages, formatScore);

		// Calculate overall maturity from core functions table instead of safeguard domains
		const coreFunctionsTable = document.querySelector('#nist2-core-functions tbody');
		var overallMaturity = 0;
		if (coreFunctionsTable) {
			let totalScore = 0;
			let scoreCount = 0;
			Array.from(coreFunctionsTable.rows).forEach(row => {
				const scoreText = row.cells[1].textContent;
				if (scoreText) {
					const score = parseFloat(scoreText);
					if (!isNaN(score)) {
						totalScore += score;
						scoreCount++;
					}
				}
			});
			
			if (scoreCount > 0) {
				overallMaturity = totalScore / scoreCount;
			}
		} else {
			// Fallback: calculate from core function averages object if table not found
			const coreFunctionValues = Object.values(coreFunctionAverages);
			if (coreFunctionValues.length > 0) {
				overallMaturity = coreFunctionValues.reduce((sum, value) => sum + value, 0) / coreFunctionValues.length;
			}
		}

		// Update the overall maturity score
		const maturityRatingRow = $('#nist2 .light-background td');
		if (maturityRatingRow.length > 0) {
			WebAssessmentCharts.overallNISTCSF2maturity = overallMaturity;
			WebAssessmentCharts.nist2CoreFunctionAverages = coreFunctionAverages;  // Store core function averages
			maturityRatingRow.text(formatScore(overallMaturity));  // jQuery method to set text
			$('.audit-overall-value').text(formatScore(overallMaturity));
			$('.nist2-overall-value').text(formatScore(overallMaturity));
			// console.log(`Updated audit-overall-value with core functions table average:`, formatScore(overallMaturity));
			WebAssessmentCharts.createChartFromTable('nist2', 'nist2-chart', charts, true);
			WebAssessmentCharts.createChartFromTable('nist2-core-functions', 'nist2-core-functions-chart', charts, true);
			showFrameworkContainer('.nist2-container');
		} else {
			console.error("Error: Maturity rating row not found in the table.");
		}
	}

	/**
	 * CIS 8.1 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function CIS81(averageScores, charts) {
		hideFrameworkContainer('.cis81-container');
		// console.log('averageScores inside CIS81:', averageScores);
		const tableBody = document.querySelector('#cis81 tbody');
		if (!tableBody) {
			console.error('CIS 8.1 Table body not found.');
			return;
		}

		// Object to store total scores and count of sub-controls for each main control
		const controlTotals = {};

		// Aggregate scores for each sub-control under each main control
		Object.keys(averageScores).forEach(key => {
			// Handle both CIS-8-0- and CIS-8-1- keys for backward compatibility
			if (key.startsWith('CIS-8-1-') || key.startsWith('CIS-8-0-')) {
				const mainControl = key.split('.')[0]; // Extract the main control

				if (!controlTotals[mainControl]) {
					controlTotals[mainControl] = { total: 0, count: 0 };
				}

				controlTotals[mainControl].total += averageScores[key];
				controlTotals[mainControl].count++;
			}
		});

		// Calculate the average for each main control and update the table
		Object.keys(controlTotals).forEach(controlKey => {
			const controlNumber = parseInt(controlKey.split('-')[3], 10) - 1; // Get the row index
			const row = tableBody.rows[controlNumber];
			if (row) {
				const averageScore = (controlTotals[controlKey].total / controlTotals[controlKey].count) * 5;
				const scoreCell = row.cells[1];
				scoreCell.textContent = averageScore.toFixed(2);
			}
		});

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row, index) => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});

	// Update the overall maturity score
	const maturityRatingRow = $('#cis81 .light-background td');
	let overallMaturity = 0;
	if (maturityRatingRow.length > 0 && scoreCount > 0) {
		overallMaturity = totalScore / scoreCount;
		WebAssessmentCharts.overallCIS81maturity = overallMaturity;
		maturityRatingRow.text(overallMaturity.toFixed(2)); // jQuery method to set text
		// Don't set audit-overall-value here - will be set from implementation groups if available
		WebAssessmentCharts.createChartFromTable('cis81', 'cis81-chart', charts, true);
		showFrameworkContainer('.cis81-container');
	} else {
		console.error("Error: No scores found or maturity rating row not found in the table.");
	}
	
	// Calculate and display implementation groups if data is available
	// Verify that cisStandardData matches the current CIS version (CIS-8-1)
	const expectedCisVersion = 'CIS-8-1';
	if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.currentCisVersion !== expectedCisVersion) {
		// console.warn(`CIS81: cisStandardData exists but is for ${WebAssessmentCharts.currentCisVersion}, expected ${expectedCisVersion}. Clearing stale data.`);
		WebAssessmentCharts.cisStandardData = null; // Clear stale data
	}
	if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.processedItems && 
	    WebAssessmentCharts.currentCisVersion === expectedCisVersion) {
		const igScores = calculateImplementationGroupScores(
			WebAssessmentCharts.processedItems,
			WebAssessmentCharts.cisStandardData.CS.Count,
			WebAssessmentCharts.cisStandardData,
			WebAssessmentCharts.qualityData || null
		);
		// console.log('Implementation Group Scores for CIS81:', igScores);
		
		// Update implementation group table
		const igTable = document.getElementById('cis81-ig');
		if (igTable) {
			const igRows = igTable.getElementsByTagName('tbody')[0].getElementsByTagName('tr');
			Object.keys(igScores).forEach((ig, index) => {
				if (igRows[index]) {
					igRows[index].cells[1].textContent = igScores[ig].toFixed(2);
				}
			});

			// Calculate and update overall maturity rating for implementation groups
			const igTotal = Object.values(igScores).reduce((sum, score) => sum + score, 0);
			const igAverage = igTotal / Object.keys(igScores).length;
			const igMaturityRow = igTable.querySelector('tfoot .light-background td');
			if (igMaturityRow) {
				igMaturityRow.textContent = igAverage.toFixed(2);
			}

			// Update audit-overall-value with implementation groups average
			$('.audit-overall-value').text(igAverage.toFixed(2));
			// console.log(`Updated audit-overall-value with implementation groups average: ${igAverage.toFixed(2)}`);

			// Create the implementation group chart
			WebAssessmentCharts.createChartFromTable('cis81-ig', 'cis81-ig-chart', charts, true);
		}
	} else {
		// Fallback: if implementation groups aren't available, use safeguard domain average
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			// console.log(`Updated audit-overall-value with safeguard domain average (fallback): ${overallMaturity.toFixed(2)}`);
		}
	}
	}

	/**
	 * CIS 8.0 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function CIS8(averageScores, charts) {
		// console.log('averageScores in CIS8 func', averageScores);
		hideFrameworkContainer('.cis8-container');
		const tableBody = document.querySelector('#cis8 tbody');
		if (!tableBody) {
			console.error('CIS 8.0 Table body not found.');
			return;
		}

		// Object to store total scores and count of sub-controls for each main control
		const controlTotals = {};

		// Aggregate scores for each sub-control under each main control
		Object.keys(averageScores).forEach(key => {
			if (key.startsWith('CIS-8-0-')) {
				// Example key format: 'CIS-8-0-5.1' => We need the '5' part for the main control
				const mainControl = key.split('.')[0]; // This splits 'CIS-8-0-5.1' into ['CIS-8-0-5', '1']
				if (!controlTotals[mainControl]) {
					controlTotals[mainControl] = { total: 0, count: 0 };
				}
				controlTotals[mainControl].total += averageScores[key];
				controlTotals[mainControl].count++;
			}
		});

		// Calculate the average for each main control and update the table
		Object.keys(controlTotals).forEach(controlKey => {
			const controlNumber = parseInt(controlKey.split('-')[3], 10) - 1; // Get the row index from the main control number
			const row = tableBody.rows[controlNumber];
			if (row) {
				const averageScore = (controlTotals[controlKey].total / controlTotals[controlKey].count) * 5;
				const scoreCell = row.cells[1];
				scoreCell.textContent = averageScore.toFixed(2);
			}
		});

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach(row => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});

	// Update the overall maturity score
	const maturityRatingRow = $('#cis8 .light-background td');
	var overallMaturity = 0;
	if (maturityRatingRow.length > 0 && scoreCount > 0) {
		overallMaturity = (totalScore / scoreCount);
		WebAssessmentCharts.overallCIS8maturity = overallMaturity;
		maturityRatingRow.text(overallMaturity.toFixed(2));  // jQuery method to set text
		// Don't set audit-overall-value here - will be set from implementation groups if available
		WebAssessmentCharts.createChartFromTable('cis8', 'cis8-chart', charts, true);
		showFrameworkContainer('.cis8-container');
	} else {
		// console.log("Error: No scores found or maturity rating row not found in the table.");
	}
	
	// Calculate and display implementation groups if data is available
	// Verify that cisStandardData matches the current CIS version (CIS-8-0)
	const expectedCisVersion = 'CIS-8-0';
	if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.currentCisVersion !== expectedCisVersion) {
		// console.warn(`CIS8: cisStandardData exists but is for ${WebAssessmentCharts.currentCisVersion}, expected ${expectedCisVersion}. Clearing stale data.`);
		WebAssessmentCharts.cisStandardData = null; // Clear stale data
	}
	if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.processedItems && 
	    WebAssessmentCharts.currentCisVersion === expectedCisVersion) {
		const igScores = calculateImplementationGroupScores(
			WebAssessmentCharts.processedItems,
			WebAssessmentCharts.cisStandardData.CS.Count,
			WebAssessmentCharts.cisStandardData,
			WebAssessmentCharts.qualityData || null
		);
		// console.log('Implementation Group Scores for CIS8:', igScores);
		
		// Update implementation group table
		const igTable = document.getElementById('cis8-ig');
		if (igTable) {
			const igRows = igTable.getElementsByTagName('tbody')[0].getElementsByTagName('tr');
			Object.keys(igScores).forEach((ig, index) => {
				if (igRows[index]) {
					igRows[index].cells[1].textContent = igScores[ig].toFixed(2);
				}
			});

			// Calculate and update overall maturity rating for implementation groups
			const igTotal = Object.values(igScores).reduce((sum, score) => sum + score, 0);
			const igAverage = igTotal / Object.keys(igScores).length;
			const igMaturityRow = igTable.querySelector('tfoot .light-background td');
			if (igMaturityRow) {
				igMaturityRow.textContent = igAverage.toFixed(2);
			}

			// Update audit-overall-value with implementation groups average
			$('.audit-overall-value').text(igAverage.toFixed(2));
			// console.log(`Updated audit-overall-value with implementation groups average: ${igAverage.toFixed(2)}`);

			// Create the implementation group chart
			WebAssessmentCharts.createChartFromTable('cis8-ig', 'cis8-ig-chart', charts, true);
		}
	} else {
		// Fallback: if implementation groups aren't available, use safeguard domain average
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			// console.log(`Updated audit-overall-value with safeguard domain average (fallback): ${overallMaturity.toFixed(2)}`);
		}
	}
	}

	/**
	 * CIS 7.1 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function CIS7(averageScores, charts) {
		// console.log('=== CIS7 DEBUG START ===');
		// console.log('averageScores in CIS7 func', averageScores);
		// console.log('Total keys in averageScores:', Object.keys(averageScores).length);
		
		// Debug: Show all CIS-related keys
		const cisKeys = Object.keys(averageScores).filter(key => key.includes('CIS'));
		// console.log('All CIS keys found:', cisKeys);
		// console.log('CIS-7-1- keys found:', Object.keys(averageScores).filter(key => key.startsWith('CIS-7-1-')));
		
		// Debug: Show sample values for CIS keys
		cisKeys.slice(0, 5).forEach(key => {
			// console.log(`Sample CIS key: ${key} = ${averageScores[key]} (type: ${typeof averageScores[key]})`);
		});
		
		hideFrameworkContainer('.cis7-container');
		const tableBody = document.querySelector('#cis7 tbody');
		if (!tableBody) {
			console.error('CIS 7.1 Table body not found.');
			return;
		}

		const controlTotals = {};
		let processedKeys = 0;
		let skippedKeys = 0;

		Object.keys(averageScores).forEach(key => {
			// Handle both CIS-7-0- and CIS-7-1- keys for backward compatibility
			if (key.startsWith('CIS-7-1-') || key.startsWith('CIS-7-0-')) {
				processedKeys++;
				const mainControl = key.split('.')[0];
				if (!controlTotals[mainControl]) {
					controlTotals[mainControl] = { total: 0, count: 0 };
				}
				controlTotals[mainControl].total += averageScores[key];
				controlTotals[mainControl].count++;
				// console.log(`Processed key: ${key} -> mainControl: ${mainControl}, value: ${averageScores[key]}`);
			} else {
				skippedKeys++;
			}
		});
		
		// console.log(`Processed ${processedKeys} CIS-7-0/1- keys, skipped ${skippedKeys} other keys`);
		// console.log('controlTotals after processing:', controlTotals);

		// console.log('=== PROCESSING CONTROL TOTALS ===');
		Object.keys(controlTotals).forEach(controlKey => {
			const controlNumber = parseInt(controlKey.split('-')[3], 10) - 1;
			const row = tableBody.rows[controlNumber];
			// console.log(`Processing controlKey: ${controlKey}, controlNumber: ${controlNumber}, row exists: ${!!row}`);
			if (row) {
				const averageScore = (controlTotals[controlKey].total / controlTotals[controlKey].count) * 5;
				const scoreCell = row.cells[1];
				scoreCell.textContent = averageScore.toFixed(2);
				// console.log(`Set score for control ${controlNumber}: ${averageScore.toFixed(2)} (from total: ${controlTotals[controlKey].total}, count: ${controlTotals[controlKey].count})`);
			} else {
				// console.log(`No row found for control number ${controlNumber}`);
			}
		});

		// console.log('=== CALCULATING OVERALL SCORE ===');
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row, index) => {
			const scoreText = row.cells[1].textContent;
			// console.log(`Row ${index}: scoreText = "${scoreText}"`);
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
					// console.log(`Added score ${score} to total (new total: ${totalScore}, count: ${scoreCount})`);
				} else {
					// console.log(`Skipped invalid score: "${scoreText}"`);
				}
			} else {
				// console.log(`Skipped empty score for row ${index}`);
			}
		});

		// console.log(`Final calculation: totalScore = ${totalScore}, scoreCount = ${scoreCount}`);

		// Update the overall maturity score
		const maturityRatingRow = $('#cis7 .light-background td');
		var overallMaturity = 0;
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			overallMaturity = (totalScore / scoreCount);
			WebAssessmentCharts.overallCIS7maturity = overallMaturity;
			// console.log(`Set overall maturity: ${overallMaturity}`);
			maturityRatingRow.text(overallMaturity.toFixed(2));  // jQuery method to set text
			// Don't set audit-overall-value here - will be set from implementation groups if available
			WebAssessmentCharts.createChartFromTable('cis7', 'cis7-chart', charts, true);
			showFrameworkContainer('.cis7-container');
		} else {
			// console.log("Error: No scores found or maturity rating row not found in the table.");
		}
		
		// Calculate and display implementation groups if data is available
		// Verify that cisStandardData matches the current CIS version
		const expectedCisVersion = WebAssessmentCharts.currentCisVersion || 'CIS-7-1';
		if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.currentCisVersion !== expectedCisVersion) {
			// console.warn(`CIS7: cisStandardData exists but is for ${WebAssessmentCharts.currentCisVersion}, expected ${expectedCisVersion}. Clearing stale data.`);
			WebAssessmentCharts.cisStandardData = null; // Clear stale data
		}
		if (WebAssessmentCharts.cisStandardData && WebAssessmentCharts.processedItems && 
		    WebAssessmentCharts.currentCisVersion === expectedCisVersion) {
			const igScores = calculateImplementationGroupScores(
				WebAssessmentCharts.processedItems,
				WebAssessmentCharts.cisStandardData.CS.Count,
				WebAssessmentCharts.cisStandardData,
				WebAssessmentCharts.qualityData
			);
			// console.log('Implementation Group Scores for CIS7:', igScores);
			
			// Update implementation group table
			const igTable = document.getElementById('cis7-ig');
			if (igTable) {
				const igRows = igTable.getElementsByTagName('tbody')[0].getElementsByTagName('tr');
				Object.keys(igScores).forEach((ig, index) => {
					if (igRows[index]) {
						igRows[index].cells[1].textContent = igScores[ig].toFixed(2);
					}
				});

				// Calculate and update overall maturity rating for implementation groups
				const igTotal = Object.values(igScores).reduce((sum, score) => sum + score, 0);
				const igAverage = igTotal / Object.keys(igScores).length;
				const igMaturityRow = igTable.querySelector('tfoot .light-background td');
				if (igMaturityRow) {
					igMaturityRow.textContent = igAverage.toFixed(2);
				}

				// Update audit-overall-value with implementation groups average
				$('.audit-overall-value').text(igAverage.toFixed(2));
				// console.log(`Updated audit-overall-value with implementation groups average: ${igAverage.toFixed(2)}`);

				// Create the implementation group chart
				WebAssessmentCharts.createChartFromTable('cis7-ig', 'cis7-ig-chart', charts, true);
			}
		} else {
			// Fallback: if implementation groups aren't available, use safeguard domain average
			if (maturityRatingRow.length > 0 && scoreCount > 0) {
				$('.audit-overall-value').text(overallMaturity.toFixed(2));
				// console.log(`Updated audit-overall-value with safeguard domain average (fallback): ${overallMaturity.toFixed(2)}`);
			}
		}
	}

	/**
	 * ISO 27002 2013 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function ISO270022013(averageScores, charts) {
		hideFrameworkContainer('.iso2013-container');
		// console.log('ISO270022013 function called');
		const tableBody = document.querySelector('#twentythirteen tbody');
		if (!tableBody) {
			console.error('ISO 27002 2013 Table body not found');
			return;
		}

		// Object to hold the aggregated scores and their counts for averaging
		let categoryScores = {};

		// Aggregate scores by main category A.X, only for ISO-27002-2013
		Object.keys(averageScores).forEach(key => {
			if (key.startsWith("ISO-27002-2013-A.")) {
				const parts = key.split('-');
				const subCategory = parts[3]; // e.g., 'A.12.4.1'
				const mainCategory = subCategory.split('.')[0] + '.' + subCategory.split('.')[1];  // e.g., 'A.12' from 'A.12.4.1'
				if (!categoryScores[mainCategory]) {
					categoryScores[mainCategory] = { total: 0, count: 0 };
				}
				categoryScores[mainCategory].total += averageScores[key];
				categoryScores[mainCategory].count++;
			}
		});

		// Calculate average scores for each main category A.X
		let categoryAverages = {};
		Object.keys(categoryScores).forEach(category => {
			categoryAverages[category] = (categoryScores[category].total / categoryScores[category].count) * 5;
		});

		// Update the table with the averaged scores
		for (let i = 0; i < tableBody.rows.length; i++) {
			const row = tableBody.rows[i];
			const categoryLabel = row.cells[0].textContent.trim();
			// Updated regex to match the pattern (A.X)
			const match = categoryLabel.match(/\(A\.(\d+)\)$/); // Looks for (A.X) at the end of the string

			if (match) {
				const category = 'A.' + match[1]; // Constructs the key as A.X
				if (categoryAverages[category] !== undefined) {
					row.cells[1].textContent = categoryAverages[category].toFixed(2);
				} else {
					row.cells[1].textContent = "0.00";  // Setting a default score if no data found
				}
			}
		}

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach(row => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});

		// Update the overall maturity score
		const maturityRatingRow = $('#twentythirteen .light-background td');
		var overallMaturity = 0;
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			overallMaturity = (totalScore / scoreCount);
			WebAssessmentCharts.overallISO270022013maturity = overallMaturity;
			maturityRatingRow.text(overallMaturity.toFixed(2));  // jQuery method to set text
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.iso2013-overall-value').text(overallMaturity.toFixed(2));
			WebAssessmentCharts.createChartFromTable('twentythirteen', 'iso-2013-chart', charts, true);
			showFrameworkContainer('.iso2013-container');
		} else {
			// console.log("Error: No scores found or maturity rating row not found in the table.");
		}
	}

	/**
	 * ISO 27002 2022 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function ISO270022022(averageScores, charts) {
		// console.log('averageScores in ISO270022022 func', averageScores);
		hideFrameworkContainer('.iso2022-container');
		const tableBody = document.querySelector('#twentytwentytwo tbody');
		if (!tableBody) {
			console.error('ISO 27002 2022 Table body not found');
			return;
		}

		// Object to hold the aggregated scores and their counts for averaging
		let categoryScores = {};

		// Aggregate scores by main category number, but only for ISO-27002-2022
		Object.keys(averageScores).forEach(key => {
			if (key.startsWith("ISO-27002-2022-")) {
				const parts = key.split('-');
				const subCategory = parts[3]; // e.g., '8.17'
				const mainCategory = subCategory.split('.')[0];  // e.g., '8' from '8.17'
				if (!categoryScores[mainCategory]) {
					categoryScores[mainCategory] = { total: 0, count: 0 };
				}
				categoryScores[mainCategory].total += averageScores[key];
				categoryScores[mainCategory].count++;
			}
		});

		// Calculate average scores for each main category
		let categoryAverages = {};
		Object.keys(categoryScores).forEach(category => {
			categoryAverages[category] = (categoryScores[category].total / categoryScores[category].count) * 5;
		});

		// Update the table with the averaged scores
		for (let i = 0; i < tableBody.rows.length; i++) {
			const row = tableBody.rows[i];
			const categoryLabel = row.cells[0].textContent.trim();
			const match = categoryLabel.match(/\((\d+)\)$/);  // Match the main category number
			if (match) {
				const category = match[1];
				if (categoryAverages[category] !== undefined) {
					row.cells[1].textContent = categoryAverages[category].toFixed(2);
				} else {
					row.cells[1].textContent = "0.00";
				}
			} else {
				// console.log(`No match found for category label: ${categoryLabel}`);
			}
		}

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach(row => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});

		// Update the overall maturity score
		const maturityRatingRow = $('#twentytwentytwo .light-background td');
		var overallMaturity = 0;
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			overallMaturity = (totalScore / scoreCount);
			WebAssessmentCharts.overallISO270022022maturity = overallMaturity;
			maturityRatingRow.text(overallMaturity.toFixed(2));  // jQuery method to set text
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.iso2022-overall-value').text(overallMaturity.toFixed(2));
			WebAssessmentCharts.createChartFromTable('twentytwentytwo', 'iso-2022-chart', charts, true);
			showFrameworkContainer('.iso2022-container');
		} else {
			// console.log("Error: No scores found or maturity rating row not found in the table.");
		}
	}

	/**
	 * NYCRR 500 2.0 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function NYCRR5002(averageScores, charts) {
		hideFrameworkContainer('.nycrr500-container');
		// console.log('averageScores in NYCRR func', averageScores);
		// Select the table body where NYCRR 500 2.0 scores are displayed
		const tableBody = document.querySelector('#nycrr500 tbody');
		if (!tableBody) {
			console.error('NYCRR 500 2 Table body not found');
			return;
		}

		// Iterate over each row in the table, except the last summary row
		for (let i = 0; i < tableBody.rows.length; i++) {
			const row = tableBody.rows[i];
			// Generate the base key for this row based on its order, starting from 500.2
			const baseKey = `500.${i + 2}`; // e.g., '500.2' for the first row

			// Aggregate scores for any subparts like '500.2.a', '500.2.b', etc.
			let totalScore = 0;
			let count = 0;

			// Check for each subpart and main part scores
			Object.keys(averageScores).forEach(key => {
				// Adjust the regex to match the key including a dot before the letter
				if (key.match(new RegExp(`NYCRR-500-2-0-${baseKey}(\\.\\w)?$`))) {
					totalScore += averageScores[key];
					count++;
				}
			});

			// If there are subparts or a main part score, calculate the average
			if (count > 0) {
				const averageScore = (totalScore / count) * 5;
				row.cells[1].textContent = averageScore.toFixed(2);
			} else {
				// console.log(`No scores found for base key: ${baseKey}, setting score to 0.00`);
				row.cells[1].textContent = "0.00"; // Default if no scores found
			}
		}

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach(row => {
			const scoreText = row.cells[1].textContent;
			if (scoreText) {
				const score = parseFloat(scoreText);
				if (!isNaN(score)) {
					totalScore += score;
					scoreCount++;
				}
			}
		});

		// Update the overall maturity score
		const maturityRatingRow = $('#nycrr500 .light-background td');
		var overallMaturity = 0;
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			overallMaturity = (totalScore / scoreCount);
			WebAssessmentCharts.overallNYCRR5002maturity = overallMaturity;
			maturityRatingRow.text(overallMaturity.toFixed(2));  // jQuery method to set text
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.nycrr-overall-value').text(overallMaturity.toFixed(2));
			// console.log(`Updated NYCRR overall maturity rating to ${overallMaturity.toFixed(2)}`);
			WebAssessmentCharts.createChartFromTable('nycrr500', 'nycrr500-chart', charts, true);
			showFrameworkContainer('.nycrr500-container');
		} else {
			// console.log("Error: No scores found or maturity rating row not found in the table.");
		}
	}

	/**
	 * FCA RM 2024 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function FCARM2024(averageScores, charts) {
		// console.log('FCARM2024 function called');
		hideFrameworkContainer('.fcarm2024-container');
		// console.log('averageScores in FCA RM 2024 func', averageScores);
		const tableBody = document.querySelector('#fcarm2024 tbody');
		const maturityRatingRow = document.querySelector('#fcarm2024 tfoot .light-background td:last-child'); // Target the last td in the tfoot for the overall score

		if (!tableBody || !maturityRatingRow) {
			console.error('FCA RM Table body or maturity rating row not found');
			return;
		}

		// Clear the existing table body
		tableBody.innerHTML = '';

		let totalScore = 0;
		let scoreCount = 0;

		// Debug: count how many averageScores keys match FCA-RM-2024
		const fcaMatchingKeys = Object.keys(averageScores).filter(key => key === 'FCA-RM-2024');
		// console.log(`DEBUG: There are ${fcaMatchingKeys.length} keys named 'FCA-RM-2024' in averageScores.`);

		if (averageScores['FCA-RM-2024']) {
			const fcaRmScores = averageScores['FCA-RM-2024'];

			// Debug: how many controltitles under FCA-RM-2024?
			const controlTitlesCount = Object.keys(fcaRmScores).length;
			// console.log(`DEBUG: FCA-RM-2024 contains ${controlTitlesCount} controltitles`);

			// Iterate over each controltitle in FCA-RM-2024
			Object.keys(fcaRmScores).forEach(controltitle => {
				let averageScore = fcaRmScores[controltitle] * 5;

				// Round the score to 2 decimal places
				averageScore = parseFloat(averageScore).toFixed(2);

				// Create a new row for each controltitle and its corresponding score
				const row = document.createElement('tr');

				// Create the first cell (td) for the controltitle
				const titleCell = document.createElement('td');
				titleCell.textContent = controltitle;
				row.appendChild(titleCell);

				// Create the second cell (td) for the score
				const scoreCell = document.createElement('td');
				scoreCell.textContent = averageScore;
				row.appendChild(scoreCell);

				// Append the row to the table body
				tableBody.appendChild(row);

				// Add to totalScore and scoreCount
				totalScore += parseFloat(averageScore);
				scoreCount++;
			});

			// console.log(`DEBUG: Rendered ${scoreCount} FCA RM 2024 rows to the table`);

			// Calculate the overall maturity score
			let overallMaturity = 0;
			if (scoreCount > 0) {
				overallMaturity = (totalScore / scoreCount).toFixed(2);
				WebAssessmentCharts.overallFCARM2024maturity = overallMaturity;
				maturityRatingRow.textContent = overallMaturity; // Update the overall maturity score in the tfoot
				$('.audit-overall-value').text(parseFloat(overallMaturity).toFixed(2));
				$('.fcarm2024-overall-value').text(parseFloat(overallMaturity).toFixed(2));
				WebAssessmentCharts.createChartFromTable('fcarm2024', 'fcarm2024-chart', charts, true);
				showFrameworkContainer('.fcarm2024-container');
			} else {
				maturityRatingRow.textContent = "0.00"; // Default if no scores found
				// console.log("No scores found for FCA-RM-2024, setting overall maturity rating to 0.00");
			}

		} else {
			// console.log('FCA-RM-2024 not found in averageScores. Here are available keys:', Object.keys(averageScores));
		}
	}

	/**
	 * UCIS3 calculation function
	 * @param {Object} averageScores - Object containing average scores by control
	 * @param {Object} charts - Charts object for creating visualizations
	 */
	function UCIS3(averageScores, charts) {
		// console.log('averageScores in UCIS3 func', averageScores);
		hideFrameworkContainer('.ucis3-container');
		// Filter the averageScores to only include keys starting with 'UC-POLICY-IS-3-'
		const filteredScores = Object.keys(averageScores).filter(key => key.startsWith('UC-POLICY-IS-3-2019'));

		if (filteredScores.length === 0) {
			// console.log('No relevant scores found for UC-POLICY-IS-3-2019');
			return;
		}

		// Select the table rows for each category
		const electronicRow = document.querySelector('.electronic');
		const minimumRow = document.querySelector('.minimum');
		const additionalRow = document.querySelector('.additional');

		if (!electronicRow || !minimumRow || !additionalRow) {
			console.error('UCIS3 Table rows for categories not found');
			return;
		}

		// Initialize accumulators for each category
		const categoryScores = {
			electronic: { total: 0, count: 0 },
			minimum: { total: 0, count: 0 },
			additional: { total: 0, count: 0 }
		};

		// Iterate over the filtered scores in averageScores
		filteredScores.forEach(key => {
			// Correctly extract the controlId after 'UC-POLICY-IS-3-2019-'
			const controlId = key.split('UC-POLICY-IS-3-2019-')[1];

			let category = '';

			// Determine which category this controlId belongs to
			if (/^SC-0001-/.test(controlId)) {
				// SC-0001-* belongs to the Minimum Cybersecurity Standard group
				category = 'minimum';
			} else if (/^SC-/.test(controlId)) {
				// Anything SC-0002 and above belongs to the Additional Cybersecurity Standards group
				category = 'additional';
			} else if (/^\d/.test(controlId)) {
				// Controlids that are just a number (like 9.2.3) belong in the Electronic Information Security Policy category
				category = 'electronic';
			}

			// Accumulate the score for this category
			const score = parseFloat(averageScores[key]);
			if (!isNaN(score)) {
				categoryScores[category].total += score;
				categoryScores[category].count++;
			}
		});

		// Calculate the averages for each category
		const electronicAverage = (categoryScores.electronic.count > 0) ?
			(categoryScores.electronic.total / categoryScores.electronic.count) * 5 : 0.00;
		const minimumAverage = (categoryScores.minimum.count > 0) ?
			(categoryScores.minimum.total / categoryScores.minimum.count) * 5 : 0.00;
		const additionalAverage = (categoryScores.additional.count > 0) ?
			(categoryScores.additional.total / categoryScores.additional.count) * 5 : 0.00;

		// Update the table with the averaged scores (ensuring they are numbers first)
		electronicRow.cells[1].textContent = electronicAverage.toFixed(2);
		minimumRow.cells[1].textContent = minimumAverage.toFixed(2);
		additionalRow.cells[1].textContent = additionalAverage.toFixed(2);

		// Calculate the overall maturity score (average of all categories)
		const totalScore = electronicAverage + minimumAverage + additionalAverage;
		const overallMaturity = (totalScore / 3).toFixed(2);
		WebAssessmentCharts.overallUCIS3maturity = overallMaturity;
		// Update the overall maturity score in the footer
		const maturityRatingRow = document.querySelector('#ucis3 .light-background td:last-child');
		if (maturityRatingRow) {
			maturityRatingRow.textContent = overallMaturity;
			$('.audit-overall-value').text(parseFloat(overallMaturity).toFixed(2));
			WebAssessmentCharts.createChartFromTable('ucis3', 'ucis3-chart', charts, true);
			showFrameworkContainer('.ucis3-container');
		} else {
			// console.log("Error: No maturity rating row found in the table.");
		}
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { NISTCSF11, NISTCSF2, CIS81, CIS8, CIS7, ISO270022013, ISO270022022, NYCRR5002, FCARM2024, UCIS3 };
	} else if (typeof window !== 'undefined') {
		window.NISTCSF11 = NISTCSF11;
		window.NISTCSF2 = NISTCSF2;
		window.CIS81 = CIS81;
		window.CIS8 = CIS8;
		window.CIS7 = CIS7;
		window.ISO270022013 = ISO270022013;
		window.ISO270022022 = ISO270022022;
		window.NYCRR5002 = NYCRR5002;
		window.FCARM2024 = FCARM2024;
		window.UCIS3 = UCIS3;
	}

})(jQuery);
